<style scoped>
.ml-2 {
  margin-left: 2px;
}

td {
  /*border: 1px solid papayawhip;*/
}

.red {
  color: var(--color-danger-light);
  /*color: orangered;*/
}

.green {
  color: var(--color-success-light);
}

.bol {
  font-weight: bold;
}

.clickable {
  cursor: pointer;
}
</style>

<template>
  <div v-show="show">
    <div class="box symbbox">
      <Row>
        <i-col span="7">
          <i-input
            size="small"
            clearable
            :placeholder="$text.tr('поиск')"
            v-model="symbolSearch"
            @on-keydown="searchCanceled($event)"
            ref="searchText"
          ></i-input>
        </i-col>
        <i-col
          span="17"
          style="text-align: right; vertical-align: center; margin-top: 0px;"
        >
          <RadioGroup
            type="button"
            size="small"
            v-model="favswitch"
            @on-change="focusSearchInput()"
          >
            <Radio
              v-if="$store.state.sys.lang === 'es'"
              label="all"
              style="font-size: 12px; width: 50px; text-align: center;"
            >
              <Icon
                style="font-size: 14px; color: rgb(230,230,230); margin-bottom: 2px;"
                type="ios-more"
              ></Icon>
            </Radio>
            <Radio
              v-else
              label="all"
              style="font-size: 12px; width: 50px; text-align: center;"
            >{{ $text.tr('ВСЕ') }}</Radio>
            <Radio
              v-if="!noFav"
              label="fav"
              style="font-size: 12px; width: 50px; text-align: center;"
            >
              <Icon
                style="font-size: 14px; color: var(--color-neutral-dark); margin-bottom: 2px;"
                type="md-heart"
              ></Icon>
            </Radio>
            <Radio
              label="btc"
              style="font-size: 12px; width: 50px; text-align: center;"
            >BTC</Radio>
            <Radio
              label="usdt"
              style="font-size: 12px; width: 50px; text-align: center;"
            >USDT</Radio>
          </RadioGroup>
        </i-col>
      </Row>
      <br>
      <table style="text-align: left; width: 100%">
        <tr style="font-weight: bold; font-size: 12px;">
          <td
            v-for="(item, ind) in symbHeaderItems"
            :style="item.style"
            :key="'symbhead-' + item.field"
          ><span
              class="clickable noselect"
              @click="sortSymbList(item.field)"
            >{{ translateSymbolsHeaders(ind) }}</span>
            <Icon
              v-if="sort.field === item.field && sort.direction === 1"
              type="md-arrow-dropup"
            />
            <Icon
              v-if="sort.field === item.field && sort.direction === -1"
              type="md-arrow-dropdown"
            />
            <!--            <div style="display: inline-block; width: 7px;" v-if="sort.field !== item.field"></div>-->
          </td>
          <td
            style="width: 100px; text-align: right; padding-right: 0px;"
            class="noselect"
          >
            <span
              class="clickable"
              @click="sortSymbList('24h')"
            >{{ $text.tr('24Ч') }}</span>
            <Icon
              v-if="sort.field === '24h' && sort.direction === 1"
              type="md-arrow-dropup"
            />
            <Icon
              v-if="sort.field === '24h' && sort.direction === -1"
              type="md-arrow-dropdown"
            />
            / <span
              class="clickable"
              @click="sortSymbList('volume')"
            >VOL</span>
            <Icon
              v-if="sort.field === 'volume' && sort.direction === 1"
              type="md-arrow-dropup"
            />
            <Icon
              v-if="sort.field === 'volume' && sort.direction === -1"
              type="md-arrow-dropdown"
            />
            <!--            <div style="display: inline-block; width: 7px;" v-if="sort.field !== '24h'"></div>-->
          </td>
        </tr>
      </table>
      <div
        id="symbols-container"
        style="height:300px;overflow-y: scroll; margin-right: -20px; font-size: 15px; font-weight: normal;"
      >
        <table style="text-align: left; width: 100%">
          <tr
            :key="symbol.baseAsset+symbol.quoteAsset"
            :id="getSymbolRowId(symbol)"
            v-bind:class="{ bol: symbol.baseAsset+'_'+symbol.quoteAsset ===  currentSymbol }"
            v-for="symbol in symbolsFiltered"
          >
            <td style="width: 45%;">
              <!-- <Icon style="cursor: pointer;" type="heart" :color="symbol.fav ? '#2d8cf0' : 'lightgray'" v-on:click="favSymbol(symbol.baseAsset+'_'+symbol.quoteAsset)"/> -->
              <!--<Icon color="#6963e3" style="cursor: pointer;" type="heart"/>-->
              <!--<Icon color="lightgray" style="cursor: pointer;" type="heart"/>-->
              <!--&nbsp<span style="cursor: pointer;">{{ symbol.baseAsset }}/{{ symbol.quoteAsset }}</span>-->

              <Icon
                color="var(--color-accent-light)"
                style="cursor: pointer;"
                type="md-heart"
                v-if="symbol.fav && !noFav"
                v-on:click="favSymbol('unfav', symbol.baseAsset+'_'+symbol.quoteAsset)"
              />
              <Icon
                color="darkgray"
                style="cursor: pointer;"
                type="md-heart"
                v-if="!symbol.fav && !noFav"
                v-on:click="favSymbol('fav', symbol.baseAsset+'_'+symbol.quoteAsset)"
              />
              <span
                :class="{'ml-2': !noFav}"
                style="cursor: pointer;"
                v-on:click="selectSymbol(symbol)"
              > {{ symbol.baseAsset }}/{{ symbol.quoteAsset }} </span>

            </td>
            <td style="width: 80px;">{{ symbol.price }}</td>
            <td
              v-if="sort.field === 'volume'"
              style="width: 60px; text-align: right; padding-right: 5px;"
            >{{ symbol.VolShort }}</td>
            <td
              v-else
              style="width: 60px; text-align: right; padding-right: 5px;"
              :class="{'red' : parseFloat(symbol.Change24h) < 0, 'green' : parseFloat(symbol.Change24h) >= 0}"
            >{{ symbol.Change24h }}%</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Apis from '@/util/apis'
import util from '@/util/util'

export default {
  name: 'Symbols',
  data: function () {
    return {
      favswitch: this.noFav ? 'all' : 'fav',
      symbolSearch: '',
      updateSymbolsInterval: null,
      sort: {
        direction: 1,
        field: 'coin'
      },
      symbHeaderItems: [
        {
          text: 'ПАРА',
          field: 'coin',
          style: { width: '46%' }
        },
        {
          text: 'ЦЕНА',
          field: 'price',
          style: { width: '80px' }
        }
        // {
        //   text: '24Ч',
        //   field: '24h',
        //   style: { width: '60px', 'text-align': 'right', 'padding-right': '0px' }
        // }
      ]
    }
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    noFav: Boolean,
    symbol: String,
    extraSymbols: Array
  },
  computed: {
    symbolsFiltered () {
      let list = []

      if (this.symbols.length) {
        this.symbols.forEach(function (item) {
          list.push(item)
        })
      }
      if (this.symbolSearch !== '') {
        list = list.filter(symbol =>
          (
            symbol.baseAsset.toLowerCase() +
            '/' +
            symbol.quoteAsset.toLowerCase()
          ).includes(this.symbolSearch.toLowerCase())
        )
      } else if (this.favswitch === 'all') {
        // list = this.symbols
      } else if (this.favswitch === 'btc') {
        list = list.filter(symbol => symbol.quoteAsset.toLowerCase() === 'btc')
      } else if (this.favswitch === 'usdt') {
        list = list.filter(symbol => symbol.quoteAsset.toLowerCase() === 'usdt')
      } else {
        list = list.filter(symbol => symbol.fav)
      }

      list.sort((a, b) => {
        let direction = 1
        switch (this.sort.field) {
          case 'coin':
            direction =
              this.symbolFromAsset(a) > this.symbolFromAsset(b) ? 1 : -1
            break
          case 'price':
            direction = parseFloat(a.price) > parseFloat(b.price) ? 1 : -1
            break
          case '24h':
            direction =
              parseFloat(a.Change24h) > parseFloat(b.Change24h) ? 1 : -1
            break
          case 'volume':
            direction =
              parseFloat(a.Volume24h) > parseFloat(b.Volume24h) ? 1 : -1
            break
        }
        return this.sort.direction * direction
      })
      return list
    },
    symbols () {
      return this.extraSymbols && this.extraSymbols.length
        ? this.extraSymbols
        : this.$store.state.data.symbols
    },
    currentSymbol () {
      return this.symbol
        ? this.symbol.replace('/', '_')
        : this.$store.state.trade.symbol
    }
  },
  watch: {
    show: function (value) {
      if (value) {
        this.symbolSearch = ''
        this.focusSearchInput()
        document.addEventListener('keydown', this.onKeydown)
        this.$nextTick(() => {
          this.scrollToCurrentRow()
        })
      } else {
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    favswitch: function (value) {
      this.$nextTick(() => {
        this.scrollToCurrentRow()
      })
    }
  },
  methods: {
    getSymbolRowId (symbol) {
      return `row_${symbol.baseAsset}_${symbol.quoteAsset}`
    },
    scrollToCurrentRow () {
      const currentRowId = 'row_' + this.currentSymbol
      const symbolsContainer = document.getElementById('symbols-container')
      const row = document.getElementById(currentRowId)

      if (row) {
        symbolsContainer.scroll({
          top: row.offsetTop,
          behavior: 'smooth'
        })
      } else {
        symbolsContainer.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    onKeydown (e) {
      if (e.repeat) {
        return
      }

      switch (e.key) {
        case 'ArrowUp':
          this.onArrowPressed(e)
          break
        case 'ArrowDown':
          this.onArrowPressed(e, 'down')
          break
      }
    },
    onArrowPressedScroll (id, isFirst) {
      const symbolsContainer = document.getElementById('symbols-container')
      const row = document.getElementById(id)
      let scrollTop = null

      if (isFirst) {
        scrollTop = 0
      } else if (
        symbolsContainer.scrollTop + symbolsContainer.offsetHeight <=
        row.offsetTop + row.offsetHeight
      ) {
        scrollTop = row.offsetTop
      } else if (symbolsContainer.scrollTop >= row.offsetTop) {
        scrollTop = symbolsContainer.scrollTop - symbolsContainer.offsetHeight
      }

      if (scrollTop !== null) {
        symbolsContainer.scroll({
          top: scrollTop,
          behavior: 'smooth'
        })
      }
    },
    onArrowPressed (e, dir = 'up') {
      e.stopPropagation()
      e.preventDefault()

      if (!this.symbolsFiltered.length) {
        return
      }
      const index =
        dir === 'up' ? this.getPreviousSymbolIndex() : this.getNextSymbolIndex()

      const newSymbol = this.symbolsFiltered[index]
      this.$emit(
        'selectSymbol',
        `${newSymbol.baseAsset}/${newSymbol.quoteAsset}`,
        true
      )

      const symbolRowId = this.getSymbolRowId(newSymbol)
      const isFirstSymbol = index === 0
      this.onArrowPressedScroll(symbolRowId, isFirstSymbol)
    },
    getPreviousSymbolIndex () {
      let index = this.getCurrentSymbolIndex()
      let previousIndex = 0

      if (index === 0) {
        previousIndex = this.symbolsFiltered.length - 1
      } else if (index !== -1) {
        previousIndex = --index
      }

      return previousIndex
    },
    getNextSymbolIndex () {
      let index = this.getCurrentSymbolIndex()
      let nextIndex = 0

      if (index === this.symbolsFiltered.length - 1) {
        nextIndex = 0
      } else if (index !== -1) {
        nextIndex = ++index
      }

      return nextIndex
    },
    getCurrentSymbolIndex () {
      const index = this.symbolsFiltered.findIndex(symbol => {
        const pair = `${symbol.baseAsset}_${symbol.quoteAsset}`
        return pair === this.currentSymbol
      })

      return index
    },
    focusSearchInput () {
      setTimeout(() => {
        this.$refs.searchText.focus()
      }, 300)
    },
    translateSymbolsHeaders (ind) {
      return this.$text.tr(this.symbHeaderItems[ind].text)
    },
    symbolFromAsset (asset) {
      return asset.baseAsset + asset.quoteAsset
    },
    sortSymbList: function (field) {
      this.sort.field = field
      this.sort.direction = -1 * this.sort.direction
    },
    selectSymbol (symbol) {
      this.$emit('selectSymbol', `${symbol.baseAsset}/${symbol.quoteAsset}`)
      this.$bus.$emit('filterTrades')
    },
    favSymbol (type, symbol) {
      let uri =
        'user/setfav?token=' +
        this.$store.state.sys.token +
        '&etid=' +
        this.$store.state.sys.tradeExchange.Id +
        '&symbol=' +
        symbol
      if (type === 'unfav') {
        uri += '&unset=1'
      }
      Apis[util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get(uri)
        .then(response => {
          if (response.data.err !== undefined) {
            console.log(response.data.err)
            return
          }
          this.symbols.forEach((part, i, theArray) => {
            if (
              theArray[i].baseAsset === symbol.split('_')[0] &&
              theArray[i].quoteAsset === symbol.split('_')[1]
            ) {
              if (type === 'unfav') {
                theArray[i].fav = false
              } else {
                theArray[i].fav = true
              }
            }
          })
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    searchCanceled (e) {
      if (e.keyCode === 27) {
        this.symbolSearch = ''
        const elem = this.$refs.searchText
        elem.blur()
      }
    }
  }
}
</script>
